import React from 'react';

import {isAndroidInAppBrowser} from '@helpers';
import {Copyright} from '@components/atoms';

export const FBKeyboardAvoidingViewPadding: React.FC = () => {
  return isAndroidInAppBrowser ? <Copyright /> : null;
};
